import { Document } from "@/models/api/mail/Document";
import { EmailContentAndSubject } from "@/models/api/mail/EmailContentAndSubject";
import { EmailAddressHint } from "@/models/api/mail/EmailAddressHint";
import { EmailAddress } from "@/models/api/mail/EmailAddress";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { MAIL_NOTIFICATION_STATUS_EMAIL_TYPE } from "@/static/mailNotificationStatusEmailTypes";

export class DocumentMailData {
  @Type(() => Document)
  @ValidateNested()
  @Expose()
  documents!: Array<Document>;
  @IsNumber()
  @Expose()
  copyCount!: number;
  @IsOptional()
  @IsString()
  @Expose()
  messageForUser!: string;
}

export class ContractorMailSettings {
  @Type(() => EmailAddress)
  @ValidateNested()
  @Expose()
  emailAddresses!: Array<EmailAddress>;
  @Type(() => EmailAddressHint)
  @ValidateNested()
  @Expose()
  emailAddressesHint!: Array<EmailAddressHint>;
  @IsBoolean()
  @Expose()
  enableXmlAccess!: boolean;
  @IsOptional()
  @IsNumber()
  @Expose()
  defaultMailbox!: null | number;
  @IsEnum(MAIL_NOTIFICATION_STATUS_EMAIL_TYPE)
  @Expose()
  defaultDocumentAccess!: MAIL_NOTIFICATION_STATUS_EMAIL_TYPE;
}

export class MailBox {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  emailAddress!: string;
}

export class NotificationData {
  @Type(() => DocumentMailData)
  @ValidateNested()
  @Expose()
  documentMailData!: DocumentMailData;
  @Type(() => EmailContentAndSubject)
  @ValidateNested()
  @Expose()
  mailContentAndSubject!: EmailContentAndSubject;
  @Type(() => ContractorMailSettings)
  @ValidateNested()
  @Expose()
  contractorMailSettings!: ContractorMailSettings;
  @Type(() => MailBox)
  @ValidateNested()
  @Expose()
  mailBoxes!: Array<MailBox>;
}
